import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";

import RoomDesigner from "./RoomDesigner";
import LedConfigurator from "./LedConfigurator";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import ProtectedRoute from "./admin/ProtectedRoute";
import ProductList from "./admin/ProductList";
import ProductForm from "./admin/ProductForm";
import LedProductList from "./admin/LedProductList";
import LedProductForm from "./admin/LedProductForm";
import AppSettings from "./admin/AppSettings";
import CatalogSettings from "./admin/CatalogSettings";
import UserManagement from "./admin/UserManagement";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Halaman utama — RoomDesigner 3D (publik, tanpa login) */}
          <Route path="/" element={<RoomDesigner />} />
          <Route path="/led-configurator" element={<LedConfigurator />} />

          {/* Login admin — publik */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Area admin — dilindungi, wajib login */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<ProductList />} />
            <Route path="products/new" element={<ProductForm />} />
            <Route path="products/:id" element={<ProductForm />} />
            <Route path="led-products" element={<LedProductList />} />
            <Route path="led-products/new" element={<LedProductForm />} />
            <Route path="led-products/:id" element={<LedProductForm />} />
            <Route path="settings" element={<AppSettings />} />
            <Route path="catalog" element={<CatalogSettings />} />
            <Route path="users" element={<UserManagement />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}